import type {
    BootstrapCommerceContextRequest,
    BootstrapCommerceContextResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";

/**
 * Stable operation used to resolve the complete Commerce runtime context.
 */
export const bootstrapCommerceContextOperation = defineCommerceOperation<
    BootstrapCommerceContextRequest,
    BootstrapCommerceContextResponse
>("commerce.context.bootstrap");
